module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/tools/angle-grinder-4ab19636e9df9b64e181fd5d32a48f25.svg";